import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, inject, watch, defineAsyncComponent } from 'vue'
import { until } from '@vueuse/core'
import { useErrorsGetter, useParsedSetter } from '@components/Forms/FormMixin'
import { feedbackCreateResource } from '@services/feedback.service'
import useGlobal from '@composables/useGlobal'
import { useUserStore } from '@store/user'
import { useShowModal } from '@composables/useModalOpener'


export default /*#__PURE__*/_defineComponent({
  __name: 'Feedback',
  setup(__props, { expose: __expose }) {
  __expose();

const PrivacyPolicy = defineAsyncComponent(() => import('@components/Authentication/PrivacyPolicy'))

const { $t } = useGlobal()
const captchaConfig = inject('captchaConfig')
const isLoad = ref(false)
const userStore = useUserStore()
const formdata = reactive({
  source: window.location.href,
  recaptcha: null,
  name: null,
  contact: null,
  message: '',
})

watch(() => userStore.getUserInfo, val => {
  const userInfo = val.info

  if (userInfo && userInfo.phone_number) {
    formdata.name = [userInfo.first_name, userInfo.last_name].join(' ')
    formdata.contact = userInfo.phone_number
  }
}, { immediate: true, deep: true })

const send = async (sendData: object, control: any) => {
  control.setFieldError('non_field_errors', '')

  if (isLoad.value) return

  captchaConfig.execute()

  await until(captchaConfig.token).changed()

  captchaConfig.resetCaptcha()

  formdata.recaptcha = captchaConfig.token

  isLoad.value = true

  feedbackCreateResource.execute({}, formdata).then(() => {
    const message = {
      title: $t('Спасибо'),
      text: $t('Ваша заявка принята'),
    }

    useShowModal(message)

    control.resetForm()
  }).catch(async (e: object) => {
    const parsed = await useErrorsGetter(e)

    useParsedSetter(parsed, control.setFieldError)
  }).finally(() => {
    isLoad.value = false
  })
}

const __returned__ = { PrivacyPolicy, $t, captchaConfig, isLoad, userStore, formdata, send, ref, reactive, inject, watch, defineAsyncComponent, get until() { return until }, get useErrorsGetter() { return useErrorsGetter }, get useParsedSetter() { return useParsedSetter }, get feedbackCreateResource() { return feedbackCreateResource }, get useGlobal() { return useGlobal }, get useUserStore() { return useUserStore }, get useShowModal() { return useShowModal } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})